
import AuthService from "@/services/AuthService";
import NavigationService from "@/services/NavigationService";
import { defineComponent } from "vue";
import GlobalStore from "@/utils/global-store";

export default defineComponent({
    name: 'GuestShroud',
    props: {
        redirect: {
            type: Boolean,
            required: false,
            default: true,
        }
    },
    computed: {
        loggedIn() {
            return GlobalStore.data.loggedIn.value;
        },
    },
    data() {
        return {
            loading: true,
        };
    },
    methods: {
        testAuth() {
            this.loading = true;
            return AuthService.getAuthUser().finally(() => {
                this.loading = false;

                if( this.loggedIn && this.redirect ) {
                    NavigationService.navigateForbiddenAuth();
                }
            });
        },
    },
    watch: {

    },
    mounted() {
        this.testAuth();
    },
});
